(function ($, w) {
    var cache = w.TMCache(24),
        version = w.GLOBAL.theme === 'horoshop_default' ? 'default' : 'mobile';

    var CreditServices = function (id) {
        this.id = id;
    };

    CreditServices.instances = {};
    CreditServices.getInstance = function (id) {
        if (this.instances[id]) {
            return this.instances[id];
        } else {
            this.instances[id] = new this(id);

            return this.instances[id];
        }
    };

    CreditServices.prototype = {
        ajaxUri: '/_widget/horoshop_creditServices_widget/renderModal/',
        selectors: {
            modal: '#credit-services',
            tabsLinks: '.j-tabs-head a',
            tabsBody: '.j-tabs-body',
            buyButton: function (id) {
                return '.j-buy-credit-button-' + id;
            }
        },
        modalHtml: null,
        init: function () {
            this.initButtons();
        },
        initButtons: function () {
            var self = this;
            this.$button = $(this.selectors.buyButton(this.id));

            this.$button
                .off('click.CreditServices')
                .on('click.CreditServices', function (e) {
                    self.clickHandler.call(self, e);
                });
        },
        clickHandler: function (e) {
            var self = this;

            if (cache.read(this.id)) {
                this.modalHtml = cache.read(this.id);
                self.openModal();
            } else {
                self.showButtonLoader();
                w.sendAjax(
                    this.ajaxUri + this.id + '/',
                    null,
                    function (status, response) {
                        if (status === 'OK') {
                            cache.write(self.id, response.html);
                            self.modalHtml = response.html;
                            self.openModal();
                        } else {
                            console.error(response);
                        }
                        self.hideButtonLoader();
                    });
            }

            e.preventDefault();
        },
        openModal: function () {
            if (version === 'default') {
                $('body').append(this.modalHtml);
                initTabs(this.selectors.modal + ' ' + this.selectors.tabsLinks);
                $(this.selectors.modal).find(this.selectors.tabsBody).height(function () {
                    return $(this).height();
                });
                w.Modal.open(this.selectors.modal, {
                    afterClose: function () {
                        this.remove();
                    }
                });
            } else {
                var self = this;

                $('body').append(this.modalHtml);
                $(this.selectors.modal).mmenu({
                    offCanvas: {
                        position: "bottom",
                        zposition: "front",
                        fullscreen: true
                    }
                });
                w.App.mmenu.addPanel('creditServices', $(this.selectors.modal));
                w.App.mmenu.getAPI('creditServices').bind('closed', function () {
                    $(self.selectors.modal).remove();
                });
                initTabs(this.selectors.modal + ' ' + this.selectors.tabsLinks, {
                    activeClass: 'is-active'
                });
                w.App.mmenu.getAPI('creditServices').open();
                $(this.selectors.modal).find(this.selectors.tabsBody).height(function () {
                    var $content = $(this),
                        $modal = $(self.selectors.modal);

                    return $modal.height() - ($content.offset().top - $modal.offset().top);
                });
            }
        },
        showButtonLoader: function () {
            if (version === 'default') {
                this.$button.addClass('is-disabled').append('<div class="loader" />');
            } else {
                this.$button.addClass('is-loading');
            }

        },
        hideButtonLoader: function () {
            if (version === 'default') {
                this.$button.removeClass('is-disabled').find('.loader').remove();
            } else {
                this.$button.removeClass('is-loading');
            }
        }
    };

    w.CreditServices = CreditServices;
})(jQuery, window);